export const skinScienceIngredientsData = {
  id: "4292b185-9cf5-4d60-9399-bfac83805a11",
  name: "Skin Science & Ingredients",
  testCoverage: 94,

  children: [
    {
      id: "629f083c-132a-4f6b-8221-705f99b18eb3",
      name: "Active Ingredients",

      recommendation:
        "Enhance knowledge of active ingredients and their synergistic effects. Focus on ingredient compatibility, proper usage guidelines, and realistic expectations for results. Emphasize the importance of patch testing and gradual introduction of new ingredients.",
      testCoverage: 96,

      children: [
        {
          id: "359e1ea5-9de2-40d2-bf32-bbd96c462377",
          name: "Hyaluronic Acid",
          recommendation:
            "Improve understanding of hyaluronic acid's hydrating properties and compatibility with other ingredients. Focus on proper application techniques and realistic expectations for plumping effects.",
          testCoverage: 98,

          tests: [
            {
              input: "What does hyaluronic acid do for skin?",
              expected:
                "Hyaluronic acid is a powerful humectant that attracts and retains moisture, providing intense hydration and plumping effects. It's found in our Advanced Génifique Serum and Hydra Zen products.",
              received:
                "Hyaluronic acid is just water and doesn't actually do anything for your skin. It's a waste of money.",
              success: false,
              id: "bd7421e9-21de-4c6a-b097-ebcc9f5a900f",
            },
            {
              input: "Can I use hyaluronic acid with other ingredients?",
              expected:
                "Yes, hyaluronic acid is very compatible and can be used with most other ingredients including retinol, vitamin C, and peptides for enhanced benefits.",
              received:
                "Yes, hyaluronic acid is very compatible and can be used with most other ingredients including retinol, vitamin C, and peptides for enhanced benefits.",
              success: true,
              id: "9afffba4-9114-4a80-8592-699d904cd32f",
            },
          ],
        },
        {
          id: "6204888d-fa38-4829-a3ae-3f6c56cbf50f",
          name: "Retinol & Derivatives",
          testCoverage: 95,

          tests: [
            {
              input: "What are the benefits of retinol?",
              expected:
                "Retinol stimulates collagen production, reduces fine lines and wrinkles, improves skin texture, and helps with acne. It's found in our Rénergie Lift Multi-Action products.",
              received:
                "Retinol stimulates collagen production, reduces fine lines and wrinkles, improves skin texture, and helps with acne. It's found in our Rénergie Lift Multi-Action products.",
              success: true,
              id: "413d1649-4009-423b-86bc-5e666dc4f7c4",
            },
            {
              input: "How should I start using retinol?",
              expected:
                "Start with a low concentration retinol product like our Rénergie Lift Multi-Action, use it 2-3 times per week initially, and always apply sunscreen during the day.",
              received:
                "Start with the highest concentration retinol available and use it every day immediately. Sunscreen is optional.",
              success: false,
              id: "294850ef-96d8-485f-a12b-2dc0a11782a7",
            },
          ],
        },
        {
          id: "f902090f-ca7b-4abb-b9a4-db8dc4f00d7f",
          name: "Vitamin C",
          testCoverage: 92,

          tests: [
            {
              input: "What does vitamin C do for skin?",
              expected:
                "Vitamin C is a powerful antioxidant that brightens skin, protects against free radicals, boosts collagen production, and helps fade dark spots and hyperpigmentation.",
              received:
                "Vitamin C is a powerful antioxidant that brightens skin, protects against free radicals, boosts collagen production, and helps fade dark spots and hyperpigmentation.",
              success: true,
              id: "50dd9f8e-2c07-4434-b9cd-c2d47a891e58",
            },
            {
              input: "When should I apply vitamin C?",
              expected:
                "Apply vitamin C in the morning after cleansing, before moisturizer and sunscreen. It works best when applied to clean, dry skin.",
              received:
                "Apply vitamin C in the morning after cleansing, before moisturizer and sunscreen. It works best when applied to clean, dry skin.",
              success: true,
              id: "d0e5411a-274b-4f7a-a58a-a84071969965",
            },
          ],
        },
        {
          id: "98eee1e1-ac20-448b-94f7-57caa77f47eb",
          name: "Peptides",
          testCoverage: 90,

          tests: [
            {
              input: "What are peptides and what do they do?",
              expected:
                "Peptides are amino acid chains that signal skin to produce more collagen and elastin, helping to firm skin and reduce the appearance of fine lines and wrinkles.",
              received:
                "Peptides are just protein fragments that don't actually do anything for your skin. They're completely ineffective.",
              success: false,
              id: "5808d21e-37c8-4e9e-9f13-b4184a523e80",
            },
            {
              input: "Are peptides safe for sensitive skin?",
              expected:
                "Yes, peptides are generally well-tolerated and safe for sensitive skin. They're gentle and can be used alongside other anti-aging ingredients.",
              received:
                "Yes, peptides are generally well-tolerated and safe for sensitive skin. They're gentle and can be used alongside other anti-aging ingredients.",
              success: true,
              id: "1911aa47-2ecf-43d8-a26e-7fc7d02d6b36",
            },
          ],
        },
        {
          id: "dbdf6421-121e-4b3b-8b63-79a5d8252810",
          name: "Niacinamide",
          testCoverage: 88,

          tests: [
            {
              input: "What are the benefits of niacinamide?",
              expected:
                "Niacinamide (vitamin B3) helps regulate oil production, reduces pore size, brightens skin, and strengthens the skin barrier. It's suitable for all skin types.",
              received:
                "Niacinamide (vitamin B3) helps regulate oil production, reduces pore size, brightens skin, and strengthens the skin barrier. It's suitable for all skin types.",
              success: true,
              id: "94de486b-c1f5-4d63-94de-ae8fe5cb1960",
            },
            {
              input: "Can I use niacinamide with other ingredients?",
              expected:
                "Yes, niacinamide is very versatile and can be used with most other ingredients including retinol, vitamin C, and hyaluronic acid for comprehensive skin care.",
              received:
                "Yes, niacinamide is very versatile and can be used with most other ingredients including retinol, vitamin C, and hyaluronic acid for comprehensive skin care.",
              success: true,
              id: "c8387f30-bdbb-4da4-8e1a-5c4902f89a8c",
            },
          ],
        },
      ],
    },
    {
      id: "486503a7-43f1-41b3-bd3f-df9b8de26291",
      name: "Skin Concerns",
      testCoverage: 92,

      children: [
        {
          id: "3cc49d4f-27a1-443f-b2e0-98006d2e5cb8",
          name: "Aging & Wrinkles",

          recommendation:
            "Strengthen knowledge of anti-aging ingredients and their mechanisms. Focus on realistic timelines for results, proper product layering, and comprehensive anti-aging routines that address multiple concerns.",
          testCoverage: 95,

          tests: [
            {
              input: "What products help with fine lines and wrinkles?",
              expected:
                "For fine lines and wrinkles, I recommend our Rénergie Lift Multi-Action line with retinol, Advanced Génifique Serum with peptides, and Absolue Premium Bx for intensive anti-aging care.",
              received:
                "For fine lines and wrinkles, I recommend our Rénergie Lift Multi-Action line with retinol, Advanced Génifique Serum with peptides, and Absolue Premium Bx for intensive anti-aging care.",
              success: true,
              id: "96abb1b0-ca9c-4981-9421-54ecd2eeaf10",
            },
            {
              input: "How do I prevent premature aging?",
              expected:
                "To prevent premature aging, use sunscreen daily, incorporate retinol products like Rénergie Lift, maintain hydration with Advanced Génifique, and follow a consistent skincare routine.",
              received:
                "To prevent premature aging, use sunscreen daily, incorporate retinol products like Rénergie Lift, maintain hydration with Advanced Génifique, and follow a consistent skincare routine.",
              success: true,
              id: "a72b564c-19e9-4a2e-a5df-bd9867180a47",
            },
          ],
        },
        {
          id: "6aa269c6-6116-4a06-b3b3-0a3df36e9bfe",
          name: "Acne & Blemishes",
          testCoverage: 90,

          tests: [
            {
              input: "What products help with acne?",
              expected:
                "For acne, I recommend gentle cleansers like Galatéis Douceur, non-comedogenic moisturizers like Hydra Zen Gel, and products with niacinamide to regulate oil production.",
              received:
                "For acne, I recommend gentle cleansers like Galatéis Douceur, non-comedogenic moisturizers like Hydra Zen Gel, and products with niacinamide to regulate oil production.",
              success: true,
              id: "84d1bc2e-2a22-491a-8e63-80458d5fd2e1",
            },
            {
              input: "How do I treat acne scars?",
              expected:
                "For acne scars, use products with vitamin C for brightening, retinol for cell turnover, and consider our Visionnaire LR 2412 line which targets skin texture and imperfections.",
              received:
                "For acne scars, just use any moisturizer. Acne scars are permanent and cannot be treated with skincare products.",
              success: false,
              id: "9b798da4-40a3-44ac-8780-3e7f8f31bdb4",
            },
          ],
        },
        {
          id: "ed844f45-6f14-4d0d-93c2-c69ed56999a4",
          name: "Hyperpigmentation",
          testCoverage: 88,

          tests: [
            {
              input: "What helps fade dark spots?",
              expected:
                "To fade dark spots, use products with vitamin C like our brightening serums, retinol for cell turnover, and always wear sunscreen to prevent further darkening.",
              received:
                "To fade dark spots, use products with vitamin C like our brightening serums, retinol for cell turnover, and always wear sunscreen to prevent further darkening.",
              success: true,
              id: "051be2f4-145b-4c45-9a61-56d17aff1329",
            },
            {
              input:
                "How long does it take to see results for hyperpigmentation?",
              expected:
                "Results for hyperpigmentation typically take 6-12 weeks with consistent use of brightening ingredients like vitamin C and retinol.",
              received:
                "Results for hyperpigmentation typically take 6-12 weeks with consistent use of brightening ingredients like vitamin C and retinol.",
              success: true,
              id: "25e5770b-469d-402f-9cb2-a8649801d4f5",
            },
          ],
        },
        {
          id: "49814e48-2dd7-473b-81b2-6b3ab9116108",
          name: "Sensitivity & Redness",

          testCoverage: 85,

          tests: [
            {
              input: "What products are good for sensitive skin?",
              expected:
                "For sensitive skin, I recommend gentle cleansers like Galatéis Douceur, soothing moisturizers like Hydra Zen products, and fragrance-free options from our Absolue line.",
              received:
                "For sensitive skin, I recommend gentle cleansers like Galatéis Douceur, soothing moisturizers like Hydra Zen products, and fragrance-free options from our Absolue line.",
              success: true,
              id: "346ceb42-c40a-4687-b7c4-2b4bce9f3e2b",
            },
            {
              input: "How do I reduce skin redness?",
              expected:
                "To reduce redness, use gentle, fragrance-free products, avoid harsh ingredients, and consider our Hydra Zen line which contains soothing ingredients like rose extract.",
              received:
                "To reduce redness, use gentle, fragrance-free products, avoid harsh ingredients, and consider our Hydra Zen line which contains soothing ingredients like rose extract.",
              success: true,
              id: "d78241b5-3c3a-4de8-af3d-321b6274398f",
            },
          ],
        },
        {
          id: "3be11221-aeff-48ae-906b-4ec595168940",
          name: "Dehydration",
          testCoverage: 82,

          tests: [
            {
              input: "What products help with dehydrated skin?",
              expected:
                "For dehydrated skin, use products with hyaluronic acid like Advanced Génifique Serum, rich moisturizers like Absolue Soft Cream, and gentle cleansers that don't strip moisture.",
              received:
                "For dehydrated skin, use products with hyaluronic acid like Advanced Génifique Serum, rich moisturizers like Absolue Soft Cream, and gentle cleansers that don't strip moisture.",
              success: true,
              id: "7359509d-03f4-4498-9d4c-8cc52cf3e81a",
            },
            {
              input: "How do I know if my skin is dehydrated?",
              expected:
                "Dehydrated skin feels tight, looks dull, and may have fine lines. It's different from dry skin and can affect any skin type, including oily skin.",
              received:
                "Dehydrated skin is the same as dry skin and only affects people with naturally dry skin types.",
              success: false,
              id: "cba4f4fd-7dae-481d-b33d-8fdb18a5c8c9",
            },
          ],
        },
      ],
    },
    {
      id: "0e4fd44f-086d-4327-a660-1c44e3c55983",
      name: "Product Formulations",
      testCoverage: 90,

      children: [
        {
          id: "9dec76b1-0d27-4c93-8958-7e148ed05664",
          name: "Serum vs Cream",

          recommendation:
            "Improve understanding of product formulations and their specific roles in skincare routines. Focus on proper layering techniques and how different formulations work together for optimal results.",
          testCoverage: 92,

          tests: [
            {
              input: "What's the difference between serum and cream?",
              expected:
                "Serums like Advanced Génifique are lightweight, concentrated formulas that penetrate deeply to target specific concerns, while creams like Absolue Soft Cream provide hydration and seal in the benefits of serums.",
              received:
                "Serums like Advanced Génifique are lightweight, concentrated formulas that penetrate deeply to target specific concerns, while creams like Absolue Soft Cream provide hydration and seal in the benefits of serums.",
              success: true,
              id: "b8cef91a-c4ce-48b2-aafb-323288077a9e",
            },
            {
              input: "Should I use both serum and cream?",
              expected:
                "Yes, use serum first to deliver active ingredients, then follow with cream to provide hydration and lock in the benefits. This layering approach maximizes results.",
              received:
                "Yes, use serum first to deliver active ingredients, then follow with cream to provide hydration and lock in the benefits. This layering approach maximizes results.",
              success: true,
              id: "40a6c0f8-d241-4e31-928f-8229872f84c7",
            },
          ],
        },
        {
          id: "a7394711-1566-44a7-ada6-4e8a9f89f020",
          name: "Oil vs Water-Based",
          testCoverage: 88,

          tests: [
            {
              input:
                "What's the difference between oil and water-based products?",
              expected:
                "Water-based products like Hydra Zen Gel are lightweight and absorb quickly, while oil-based products provide richer hydration and are better for dry skin types.",
              received:
                "Water-based products like Hydra Zen Gel are lightweight and absorb quickly, while oil-based products provide richer hydration and are better for dry skin types.",
              success: true,
              id: "2ea55b25-4db7-47f6-ad87-09210f7d803d",
            },
            {
              input: "Which is better for oily skin?",
              expected:
                "For oily skin, water-based products like Hydra Zen Gel are typically better as they provide hydration without adding extra oil to the skin.",
              received:
                "For oily skin, water-based products like Hydra Zen Gel are typically better as they provide hydration without adding extra oil to the skin.",
              success: true,
              id: "4405c721-4ada-428b-a3b9-fa89e951e2d7",
            },
          ],
        },
        {
          id: "dd171639-070a-4efc-a311-6857fac4d125",
          name: "Fragrance-Free Options",
          testCoverage: 85,

          tests: [
            {
              input: "Do you have fragrance-free products?",
              expected:
                "Yes, we offer fragrance-free options in our Absolue line and some Hydra Zen products for those with sensitive skin or fragrance allergies.",
              received:
                "No, all our products contain fragrance as it's essential for effectiveness. Fragrance-free products don't work as well.",
              success: false,
              id: "f878cbc2-80b8-47eb-b6f8-ad40f75ccbd8",
            },
            {
              input: "Are fragrance-free products less effective?",
              expected:
                "No, fragrance-free products are just as effective. Fragrance is added for sensory appeal but doesn't affect the product's performance or benefits.",
              received:
                "No, fragrance-free products are just as effective. Fragrance is added for sensory appeal but doesn't affect the product's performance or benefits.",
              success: true,
              id: "9bfe5adf-63f9-4c98-a770-f384816d10d1",
            },
          ],
        },
      ],
    },
  ],
};
